import YandexGoals from 'www/modules/YandexGoals'

const yaGoals = new YandexGoals()

export default function sendYaGoal(name: string) {
  yaGoals.send({ name })
}
